<template>
  <div class="zwx-headline">
    <div class="zwx-head-title">
      <i class="zwx-head-title-line" />
      <span :class="isRequired">{{ title }}</span>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseHeadline',
  props: { title: { type: String }, required: { type: Boolean, default: false } },
  computed: {
    isRequired() {
      return this.required ? 'zwx-head-title-required' : ''
    },
  },
}
</script>

<style lang="less" scoped>
.zwx-headline {
  .zwx-head-title-line {
    display: inline-block;
    width: 4px;
    height: 14px;
    line-height: 36px;
    background: #505b89;
    margin-right: 10px;
  }
  .zwx-head-title {
    height: 42px ;
    line-height: 42px ;
    font-size: 14px;
    padding-left: 20px;
    color: #505b89;
    display: flex;
    align-items: center;
    border-top: solid 1px #d5d9e0 !important;
    border-bottom: solid 1px #d5d9e0 !important;
    background: #FFFFFF !important;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .zwx-head-title-required::before {
    content: '*' !important;
    margin-right: 4px;
    color: #ff4949 !important;
    font-weight: 400 !important;
  }
  .zwx-button {
    margin-left: 12px !important;
  }
}

.no-border .zwx-head-title,
.no-bottom .zwx-head-title {
  border-bottom: none !important;
}

.no-border .zwx-head-title,
.no-top .zwx-head-title {
  border-top: none !important;
}
</style>

